export const CUSTOM_REQUEST = "CUSTOM_REQUEST";
export const CUSTOM_REQUEST_SUCCESS = "CUSTOM_REQUEST_SUCCESS";
export const CUSTOM_REQUEST_ERROR = "CUSTOM_REQUEST_ERROR";
export const CUSTOM_REQUEST_CLEAR_DATA = "CUSTOM_REQUEST_CLEAR_DATA";
